import Fuse from "fuse.js";
import type { TermSummary } from "./types";

export type TermSearchIndex = Fuse<TermSummary>;

/** Fuzzy search over label, prefixed name, and comment — backs the Explorer's search box. */
export function buildSearchIndex(terms: TermSummary[]): TermSearchIndex {
  return new Fuse(terms, {
    keys: [
      { name: "label", weight: 2 },
      { name: "prefixedName", weight: 1.75 },
      { name: "iri", weight: 1 },
      { name: "comment", weight: 0.5 },
    ],
    threshold: 0.35,
    ignoreLocation: true,
    minMatchCharLength: 2,
  });
}

export function searchTerms(
  index: TermSearchIndex,
  query: string,
  limit = 25,
): TermSummary[] {
  if (!query.trim()) return [];
  return index
    .search(query, { limit })
    .map((result) => result.item);
}
